/**
 * GiftCardsListToolbar — search box + status/source filters + Clear + count
 * (BON-223).
 */
import { SearchInput } from '../dashboards/primitives/SearchInput';

import { GiftCardsFilterSelect } from './GiftCardsFilterSelect';
import {
  GIFT_CARD_SOURCE_OPTIONS,
  GIFT_CARD_STATUS_OPTIONS,
  giftCardCountLabel,
  isGiftCardFiltered,
} from './giftCardsModel';
import type { GiftCardSourceFilter, GiftCardStatusFilter } from './giftCardTypes';

export interface GiftCardsListToolbarProps {
  searchInput: string;
  onSearchInputChange: (v: string) => void;
  status: GiftCardStatusFilter;
  onStatusChange: (v: GiftCardStatusFilter) => void;
  source: GiftCardSourceFilter;
  onSourceChange: (v: GiftCardSourceFilter) => void;
  onClear: () => void;
  total: number;
}

export function GiftCardsListToolbar({
  searchInput,
  onSearchInputChange,
  status,
  onStatusChange,
  source,
  onSourceChange,
  onClear,
  total,
}: GiftCardsListToolbarProps) {
  const filtered = isGiftCardFiltered({ search: searchInput, status, source });
  return (
    <div
      style={{
        flex: '0 0 auto',
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        padding: '10px 14px',
        borderBottom: '1px solid var(--nb-border)',
        flexWrap: 'wrap',
      }}
    >
      <SearchInput
        value={searchInput}
        onChange={onSearchInputChange}
        placeholder="Search name, email, or card number…"
        ariaLabel="Search gift cards by name, email, or card number"
        style={{ width: 280, flex: '0 0 auto' }}
      />
      <GiftCardsFilterSelect
        label="Status"
        value={status}
        options={GIFT_CARD_STATUS_OPTIONS}
        onChange={onStatusChange}
      />
      <GiftCardsFilterSelect
        label="Source"
        value={source}
        options={GIFT_CARD_SOURCE_OPTIONS}
        onChange={onSourceChange}
      />
      {filtered && (
        <button
          type="button"
          className="nb-btn nb-btn-ghost"
          style={{ height: 28 }}
          onClick={onClear}
        >
          Clear
        </button>
      )}
      <span style={{ flex: 1 }} />
      <span style={{ fontSize: 12, color: 'var(--nb-subtle)' }}>{giftCardCountLabel(total)}</span>
    </div>
  );
}
